import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { MomentModule } from 'ngx-moment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomCommonModule } from './common/common.module';
import { DataService } from './common/services/data.service';
import { HomeService } from './common/services/home.service';
import { UserCacheService } from './common/services/user-cache.service';
import { PageNotFoundComponent } from './pages/public/page-not-found/page-not-found.component';
import { AppConfigService } from './main/app-config.service';
import { APP_INITIALIZER } from '@angular/core';

@NgModule({ declarations: [
        AppComponent,
        PageNotFoundComponent,
    ],
    // providers: [{ provide: APP_BASE_HREF, useValue: '/sae/' }],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
        AppRoutingModule,
        CommonModule,
        CustomCommonModule,
        ReactiveFormsModule,
        NgIdleKeepaliveModule.forRoot(),
        MomentModule], providers: [UserCacheService, DataService, HomeService, provideHttpClient(withXhr(), withInterceptorsFromDi()), { provide: APP_INITIALIZER, useFactory: appConfigInitializer, deps: [AppConfigService], multi: true }] })
export class AppModule { }
export function appConfigInitializer(appConfig: AppConfigService) {
  return () => appConfig.loadConfig();  // must return a function that returns a Promise
}